import React from 'react';
import EditIcon from './EditIcon';

/**
 * Displays the common
 */
export default function SectionWell({ sectionId, title, onEdit, changesSaved, children, editKey }) {
	return (
		<div className="confirmation-section">
			<div id={sectionId}>
				<h3 className="confirmation-well-header">
					{title ?? ''}
					{onEdit && (
						<EditIcon title={title} onClick={onEdit} editKey={editKey} className="btn btn-edit btn-primary" editEl="Edit" />
					)}
					{changesSaved && (
						<small><span className="ms-2 text-success">Changes saved<i className="ms-1 fa fa-check-circle"></i></span></small>
					)}
				</h3>
				{children}
			</div>
		</div>
	);
}
